import { Clock3, Mail, MapPin, Phone } from 'lucide-react';
import { company } from '@/data/company';

const info = [
  {
    label: 'Email',
    value: company.email,
    href: `mailto:${company.email}`,
    Icon: Mail
  },
  {
    label: 'Telefon',
    value: company.phone,
    href: `tel:${company.phoneHref}`,
    Icon: Phone
  },
  { label: 'Adresa', value: company.address, Icon: MapPin },
  { label: 'Radno vreme', value: company.workingHours, Icon: Clock3 }
];

export function ContactInfo() {
  return (
    <div className="border-t border-border">
      {info.map(item => {
        const content = (
          <>
            <item.Icon
              aria-hidden="true"
              className="mt-1 size-4 shrink-0 text-text-muted"
            />
            <span className="grid flex-1 gap-1 sm:grid-cols-[0.35fr_0.65fr] sm:gap-4">
              <span className="text-sm font-medium text-text-primary">
                {item.label}
              </span>
              <span
                className={`w-fit text-sm leading-6 text-text-secondary ${item.href ? 'animated-link' : ''}`}
              >
                {item.value}
              </span>
            </span>
          </>
        );

        return item.href ? (
          <a
            key={item.label}
            className="flex gap-4 border-b border-border py-4 transition-colors hover:text-primary"
            href={item.href}
          >
            {content}
          </a>
        ) : (
          <div
            key={item.label}
            className="flex gap-4 border-b border-border py-4"
          >
            {content}
          </div>
        );
      })}
    </div>
  );
}
